/* Maniac VIP early access: unlocken met het gedeelde wachtwoord of via de
   automatische e-mailcheck. Zacht slot (besluit Marlot 26-8-2026): de status
   staat in localStorage en geldt voor alle VIP-designs tegelijk.
   Server: Cloudflare worker maniac-vip (vip_programma/worker/worker.js). */
(function () {
  var WORKER = "https://maniac-vip.maniac-nails.workers.dev";
  var KEY = "maniac_vip_unlocked";

  function unlocked() {
    try { return localStorage.getItem(KEY) === "1"; } catch (e) { return false; }
  }
  function setUnlocked() {
    try { localStorage.setItem(KEY, "1"); } catch (e) { /* prive-modus */ }
    document.documentElement.classList.add("vip-unlocked");
    document.documentElement.classList.remove("vip-locked-page");
  }
  // Testhulp: ?vip=reset in de URL wist de unlock, zodat je de vergrendelde
  // staat kunt bekijken zonder incognitovenster.
  if (new URLSearchParams(location.search).get("vip") === "reset") {
    try { localStorage.removeItem(KEY); } catch (e) {}
    document.documentElement.classList.remove("vip-unlocked");
  }
  if (unlocked()) document.documentElement.classList.add("vip-unlocked");

  function tekst(el, naam) {
    return el.getAttribute("data-" + naam) || "";
  }

  function toon(el, bericht, ok) {
    el.textContent = "";
    el.className = "vip-unlock-feedback " + (ok ? "is-success" : "is-error");
    el.insertAdjacentText("afterbegin", bericht);
  }

  function init(blok) {
    var feedback = blok.querySelector(".vip-unlock-feedback");
    var wwForm = blok.querySelector("[data-vip-password-form]");
    var mailForm = blok.querySelector("[data-vip-email-form]");

    if (wwForm) {
      wwForm.addEventListener("submit", function (e) {
        e.preventDefault();
        var ww = wwForm.querySelector("input[type=password]").value;
        fetch(WORKER + "/unlock", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ password: ww }),
        }).then(function (r) { return r.json(); }).then(function (d) {
          if (d.ok) {
            setUnlocked();
            toon(feedback, tekst(blok, "txt-open"), true);
          } else {
            toon(feedback, tekst(blok, "txt-wrong"), false);
          }
        }).catch(function () {
          toon(feedback, tekst(blok, "txt-error"), false);
        });
      });
    }

    if (mailForm) {
      mailForm.addEventListener("submit", function (e) {
        e.preventDefault();
        var email = mailForm.querySelector("input[type=email]").value;
        var optin = mailForm.querySelector("input[type=checkbox]");
        var knop = mailForm.querySelector("button");
        knop.disabled = true;
        fetch(WORKER + "/check", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: email, newsletter: !!(optin && optin.checked) }),
        }).then(function (r) { return r.json(); }).then(function (d) {
          knop.disabled = false;
          if (d.ok && d.vip) {
            // Direct op het scherm: afgemelde profielen krijgen geen mail,
            // dus het antwoord mag nooit alleen per mail komen.
            toon(feedback, tekst(blok, "txt-vip"), true);
            var chip = document.createElement("span");
            chip.className = "vip-password-reveal";
            chip.textContent = d.password;
            feedback.appendChild(chip);
            setUnlocked();
          } else if (d.ok) {
            var zin = tekst(blok, "txt-notyet").replace("[X]", d.needed);
            toon(feedback, zin, false);
          } else {
            toon(feedback, d.error || tekst(blok, "txt-error"), false);
          }
        }).catch(function () {
          knop.disabled = false;
          toon(feedback, tekst(blok, "txt-error"), false);
        });
      });
    }
  }

  function start() {
    // Vergrendelde PDP: ook de secties onder het product dicht (beschrijving,
    // aanbevelingen), zodat er niets te zien is behalve titel, foto's en het
    // unlock-blok (besluit Marlot 27-8-2026).
    if (!unlocked() && document.querySelector(".product--vip-locked")) {
      document.documentElement.classList.add("vip-locked-page");
    }
    document.querySelectorAll("[data-vip-unlock]").forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
